import React, { useState, useContext } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import BookerContext from '../../context/bookerContext';
import { useValidatedInput } from '../../hooks/useValidatedInput';
import validateValue from '../../utils/validateValue';
import fieldParams from '../../const/fieldParams';
import '../../assets/styles/error.sass';

const EmailInput = ({ fieldKey, error }) => {
  const { type, inputMode, key, label, placeholder, pattern, autocomplete, required, errorMessage } =
    fieldParams[fieldKey];
  const context = useContext(BookerContext);
  const {
    state: { accountCreation },
  } = context;
  const { value: email = '' } = useSelector(({ email }) => email || {});
  const dispatch = useDispatch();

  const [value, setValue] = useState(email);
  const [isEmailValid, setIsEmailValid] = useState(email ? validateValue(email, pattern) : true);
  const [setIsValid] = useValidatedInput('btn-view', required ? email?.length : true);
  const labelText = typeof label === 'function' ? label(accountCreation?.flow ?? '') : label;
  const placeholderText = typeof placeholder === 'function' ? placeholder(accountCreation?.flow ?? '') : placeholder;

  const changeValueHandler = e => {
    const {
      target: { value },
    } = e;
    if (!value) {
      setValue('');
      dispatch({
        type: 'updateEmail',
        email: '',
      });
      setIsValid(false);
      setIsEmailValid(true);
      return;
    }
    setValue(value);
    const isValidEmail = validateValue(value, pattern);
    dispatch({
      type: 'updateEmail',
      email: { value, isValid: isValidEmail },
    });
    setIsValid(isValidEmail);
  };

  const onBlur = () => {
    if (!value) return;

    setIsEmailValid(email ? validateValue(email, pattern) : true);
  };

  return (
    <div className={`form-group form-group-${key}${value && !isEmailValid ? ' error-group' : ''}`}>
      <label htmlFor={key} className={`form-label${value === '' ? ' hidden' : ''}`}>
        {labelText}
      </label>
      <input
        name={key}
        id={key}
        type={type}
        inputMode={inputMode}
        className={`form-input ${key}`}
        value={value}
        onChange={changeValueHandler}
        onBlur={onBlur}
        {...(placeholderText && { placeholder: placeholderText })}
        {...(pattern && { pattern: pattern })}
        {...(required && { required: true })}
        {...(autocomplete && { autoComplete: autocomplete })}
      />

      {value && (!isEmailValid || error) && <p className={'error'}>{errorMessage}</p>}
    </div>
  );
};

export default EmailInput;
